import React, { FC } from 'react';
import { Box, Container, makeStyles, Theme, Typography } from '@material-ui/core';
import { useMediaUp } from 'hooks';
import { LinkButton } from 'components/atoms';
import { ledServices } from 'images/us-energy-solutions';

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    margin: theme.spacing(10, 0),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(15, 0),
    },
  },
  image: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 844,
    },
  },
  button: {
    marginTop: theme.spacing(4),
  },
}));

const LEDServices: FC = () => {
  const classes = useStyles();
  const isSmallUp = useMediaUp('sm');

  return (
    <Box className={classes.wrapper}>
      <Container>
        <Box maxWidth={780} mx="auto">
          <Typography variant={isSmallUp ? 'h1' : 'h2'} align="center">
            LED Services
          </Typography>
          <Box mt={4} mb={10} textAlign="center">
            <Typography>
              US Energy Solutions believes that reaching greater energy efficiency implies tailoring a new and advanced approach
              to energy management. Businesses nationwide can now benefit from switching to LEDs thanks to the expanded
              versatility in the LED lighting options.
            </Typography>
            <LinkButton
              href="https://usenergysolutions.us/led-services"
              color="primary"
              variant="contained"
              className={classes.button}
            >
              Give it a go
            </LinkButton>
          </Box>
          <Box display="flex" justifyContent="center">
            <img src={ledServices} alt={'LED Services'} className={classes.image} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default LEDServices;
